import React from 'react';
import { TextInput, Tooltip } from '@mantine/core';
import { BaseFieldProps } from './types';

export function DefaultField<T extends Record<string, unknown>>({
  entityMetadata,
  fieldLabel,
  disabled,
  rightValue,
  form,
  formFieldName,
  fieldName,
  variant,
  tooltip,
  onChange,
}: BaseFieldProps<T> & { tooltip?: string }) {
  const inputProps = form.getInputProps(formFieldName);

  const input = (
    <TextInput
      id={formFieldName}
      required={!entityMetadata.isOptional}
      label={fieldLabel}
      labelProps={{ variant: 'light' }}
      placeholder=""
      disabled={disabled}
      rightSection={rightValue}
      {...inputProps}
      key={form.key(formFieldName)}
      variant={variant}
      name={fieldName}
      onChange={value => onChange(value, fieldName)}
    />
  );

  return tooltip ? (
    <Tooltip label={tooltip} position={'bottom-start'} withArrow>
      {input}
    </Tooltip>
  ) : (
    input
  );
}
